import ArticleArchive from "./vue/ArticleArchive.vue";

globalThis.__VUE_PROD_DEVTOOLS__ = true;
globalThis.__VUE_OPTIONS_API__ = true;

import "lazysizes";
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

lazySizes.cfg.minSize = 1;
lazySizes.init();

import "wicg-inert";
import 'large-small-dynamic-viewport-units-polyfill';

import MobileMenu from "./vue/MobileMenu.vue";
import * as Vue from "vue";
import SearchOverlay from "./vue/SearchOverlay.vue";

document.addEventListener('DOMContentLoaded', () => {
    const appRoots = document.querySelectorAll('.js-vue');

    for (const root of appRoots) {
        const app = Vue.createApp({
            components: {
                'mobile-menu': MobileMenu,
                'article-archive': ArticleArchive,
                'search-overlay': SearchOverlay,
            },
        });
        app.mount(root);
    }
})

document.addEventListener('DOMContentLoaded', () => {

    // Menu
    let buttons = document.querySelectorAll('.js-header-hamburger');
    for (const button of buttons) {
        button.addEventListener('click', (event) => {
            const customEvent = new CustomEvent('open-modal-menu', {});
            document.dispatchEvent(customEvent);
        });
    }

    // Search
    let buttons2 = document.querySelectorAll('.js-header-search');
    for (const button of buttons2) {
        button.addEventListener('click', (event) => {
            const customEvent = new CustomEvent('open-search-overlay', {});
            document.dispatchEvent(customEvent);
        });
    }
})

/*let forms = document.querySelectorAll('.js-header-search, .js-search-page-search')

for (let form of forms) {
    form.addEventListener('submit', (event) => {
        let target = event.currentTarget;
        let button = target.querySelector('.js-svg-wrapper-search');
        if (button) {
            button.classList.add('svg-wrapper--hide');
        }
        let button2 = target.querySelector('.js-svg-wrapper-spinner');
        if (button2) {
            button2.classList.remove('svg-wrapper--hide');
        }
    }, false);
}*/

// If scrolled, add class "header--scrolled" to the element with class "header"

let header = document.querySelector('.header');
if (header) {
    window.addEventListener('scroll', (event) => {
        if (window.scrollY > 0 || document.documentElement.classList.contains('menu-open')) {
            header.classList.add('header--scrolled');
        } else {
            header.classList.remove('header--scrolled');
        }
    });
}